// extracted by mini-css-extract-plugin
export var Section = "TopManagement-module--Section--idE9s";
export var LangHY = "TopManagement-module--LangHY--L9Yh-";
export var Name = "TopManagement-module--Name--oIjg0";
export var Position = "TopManagement-module--Position--jOdRF";
export var SectionTitle = "TopManagement-module--SectionTitle--B6M6a";
export var Row = "TopManagement-module--Row--FbctX";
export var Card = "TopManagement-module--Card--xD-FZ";
export var Photo = "TopManagement-module--Photo--QUDMH";
export var Info = "TopManagement-module--Info--MseMf";
export var NameRow = "TopManagement-module--NameRow--OcdNX";
export var Dash = "TopManagement-module--Dash--Y9wvL";
export var arrowLeft = "TopManagement-module--arrowLeft--25jx2";
export var arrowRight = "TopManagement-module--arrowRight--ZEJKM";